import type { Interfaces, } from "@bracket/chainography/interfaces";

export const addresses: Interfaces[] = [
	{
		address: "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419",
		name: "ETH_USD",
		symbol: "ETH_USD",
		implements: [ "IContractDefinition", "ITokenDefinition" ],
		decimals: 18,
	},
	{
		"address": "0xF4030086522a5bEEa4988F8cA5B36dbC97BeE88c",
		"name": "BTC_USD",
		"symbol": "BTC_USD",
		"implements": [ "IContractDefinition", "ITokenDefinition" ],
		"decimals": 8,
	}
];

